var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglepubsub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{filter:url(#luminosity-noclip);}.cls-2{fill:#669df6;}.cls-3{mask:url(#mask);}.cls-4{fill:#4285f4;}.cls-5{fill:#aecbfa;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 4.64,
    y: 4.19,
    width: 14.73,
    height: 12.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 4.64,
    y: 4.19,
    width: 14.73,
    height: 12.76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12.23,
    r: 3.58
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_Pub-Sub_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.97,
    cy: 8.21,
    r: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.03,
    cy: 8.21,
    r: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12,
    cy: 20.28,
    r: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 14.69,
    y: 10.22,
    width: 1.59,
    height: 8.04,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -4.59, 20.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.49,
    y: 13.45,
    width: 8.04,
    height: 1.59,
    transform: "translate(-5.98 6.17) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11.2,
    y: 4.19,
    width: 1.59,
    height: 8.04
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12,
    cy: 12.23,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 5.03,
    cy: 16.25,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 18.97,
    cy: 16.25,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12,
    cy: 4.19,
    r: 2.19
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepubsub);
export default __webpack_public_path__ + "static/media/Google pubsub.9927679f2be6733c9e6a8b2a9157b112.svg";
export { ForwardRef as ReactComponent };